var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.2713 28.0696L30.0102 23.3259H24.532L27.2713 28.0696Z",
    fill: "#7BFBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.532 22.5349H30.0102L27.2713 17.791L24.532 22.5349Z",
    fill: "#7BFBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2713 16.2099L30.0102 11.4652H24.532L27.2713 16.2099Z",
    fill: "#7BFBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5767 16.2099L16.315 11.4652H10.8371L13.5767 16.2099Z",
    fill: "#7BFBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8371 10.6741H16.315L13.5767 5.93042L10.8371 10.6741Z",
    fill: "#7BFBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.532 10.6741H30.0102L27.2713 5.93042L24.532 10.6741Z",
    fill: "#7BFBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.72794 28.0696L9.46754 23.3259H3.98975L6.72794 28.0696Z",
    fill: "#7BFBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.98975 22.5349H9.46754L6.72794 17.791L3.98975 22.5349Z",
    fill: "#7BFBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6957 22.1394L33.434 17.3956H27.9556L30.6957 22.1394Z",
    fill: "#7BFBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.3047 22.1394L6.0443 17.3956H0.56604L3.3047 22.1394Z",
    fill: "#7BFBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.56604 16.6045H6.0443L3.3047 11.8608L0.56604 16.6045Z",
    fill: "#7BFBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5767 28.0696L16.315 23.3259H10.8371L13.5767 28.0696Z",
    fill: "#7BFBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8371 22.5349H16.315L13.5767 17.791L10.8371 22.5349Z",
    fill: "#7BFBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.41388 28.4652H12.8907L10.1521 23.7214L7.41388 28.4652Z",
    fill: "#7BFBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1092 28.4652H26.5867L23.8483 23.7214L21.1092 28.4652Z",
    fill: "#7BFBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4226 28.0696L23.1628 23.3259H17.6846L20.4226 28.0696Z",
    fill: "#7BFBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6846 22.5349H23.1628L20.4226 17.791L17.6846 22.5349Z",
    fill: "#7BFBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 22.1394L19.7392 17.3956H14.2604L17 22.1394Z",
    fill: "#7BFBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8483 34L26.5867 29.2563H21.1092L23.8483 34Z",
    fill: "#7BFBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1521 34L12.8907 29.2563H7.41388L10.1521 34Z",
    fill: "#7BFBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2604 16.6045H19.7392L17 11.8608L14.2604 16.6045Z",
    fill: "#7BFBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9556 16.6045H33.434L30.6957 11.8608L27.9556 16.6045Z",
    fill: "#7BFBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4226 16.2099L23.1628 11.4652H17.6846L20.4226 16.2099Z",
    fill: "#7BFBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.72794 16.2099L9.46754 11.4652H3.98975L6.72794 16.2099Z",
    fill: "#7BFBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.98975 10.6741H9.46754L6.72794 5.93042L3.98975 10.6741Z",
    fill: "#7BFBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6846 10.6741H23.1628L20.4226 5.93042L17.6846 10.6741Z",
    fill: "#7BFBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8483 10.2795L26.5867 5.53485H21.1092L23.8483 10.2795Z",
    fill: "#7BFBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1521 10.2795L12.8907 5.53485H7.41388L10.1521 10.2795Z",
    fill: "#7BFBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.41388 4.74466H12.8907L10.1521 0L7.41388 4.74466Z",
    fill: "#7BFBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1092 4.74466H26.5867L23.8483 0L21.1092 4.74466Z",
    fill: "#7BFBF4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_321"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.fc1af64d7b64f04a552aad92fb2d4880.svg";
export { ForwardRef as ReactComponent };